/**
 * Collection PLP — toolbar, filters, sort, wishlist, carousels (task 1.2.2 / 1.2.7)
 * ciw-native-sort-flow
 * Loaded only from sections/main-collection-product-grid.liquid
 */
(function () {
  if (!document.body.classList.contains('template-collection')) return;

  var CIW_RESET_SCROLL_KEY = 'ciw-collection-reset-scroll';
  var CIW_NATIVE_SORT_LOADING_KEY = 'ciw-native-sort-loading';
  var CIW_NATIVE_SORT_BOOT_SKELETON_ID = 'ciw-native-sort-boot-skeleton';

  function ciwSetGridWrapLoading(loading) {
    var gridWrap = document.querySelector('.ciw-product-grid-wrap');
    if (!gridWrap) return;
    if (loading) {
      gridWrap.classList.add('is-loading');
      return;
    }
    gridWrap.classList.remove('is-loading');
  }

  function ciwRemoveNativeSortBootSkeleton() {
    var bootSkeleton = document.getElementById(CIW_NATIVE_SORT_BOOT_SKELETON_ID);
    if (bootSkeleton) bootSkeleton.remove();
  }

  function ciwShowNativeSortPageOverlay() {
    try {
      sessionStorage.setItem(CIW_NATIVE_SORT_LOADING_KEY, '1');
    } catch (err) {
      /* ignore */
    }

    document.documentElement.classList.add('ciw-native-sort-loading');
    ciwSetGridWrapLoading(true);
  }

  function ciwHideNativeSortPageOverlay() {
    try {
      sessionStorage.removeItem(CIW_NATIVE_SORT_LOADING_KEY);
    } catch (err) {
      /* ignore */
    }

    document.documentElement.classList.remove('ciw-native-sort-loading');
    ciwRemoveNativeSortBootSkeleton();
    ciwSetGridWrapLoading(false);

    var skeleton = document.querySelector('[data-ciw-plp-skeleton]');
    if (skeleton) {
      skeleton.setAttribute('aria-busy', 'false');
    }
  }

  function ciwHandoffBootSkeletonToGrid() {
    var bootSkeleton = document.getElementById(CIW_NATIVE_SORT_BOOT_SKELETON_ID);
    var wrapSkeleton = document.querySelector(
      '.ciw-product-grid-wrap.is-loading [data-ciw-plp-skeleton]'
    );
    if (bootSkeleton && wrapSkeleton) {
      bootSkeleton.remove();
    }
  }

  window.ciwShowNativeSortPageOverlay = ciwShowNativeSortPageOverlay;
  window.ciwHideNativeSortPageOverlay = ciwHideNativeSortPageOverlay;

  function hrefToSearchParams(href) {
    return new URL(href, window.location.origin).search.slice(1);
  }

  function renderFromFacetFilters(href) {
    if (typeof FacetFiltersForm === 'undefined') return false;
    var target = new URL(href, window.location.origin);
    if (target.pathname !== window.location.pathname) return false;
    FacetFiltersForm.renderPage(hrefToSearchParams(href));
    return true;
  }

  function preserveScrollForCollectionReset() {
    try {
      sessionStorage.setItem(CIW_RESET_SCROLL_KEY, String(window.scrollY));
    } catch (err) {
      /* ignore */
    }
  }

  function clearGridLoadingArtifacts() {
    var productGrid = document.getElementById('product-grid');
    if (productGrid) {
      productGrid.style.removeProperty('min-height');
    }
    var gridWrap = document.querySelector('.ciw-product-grid-wrap');
    if (gridWrap) {
      gridWrap.classList.remove('is-loading');
    }
  }

  function restorePreservedCollectionScroll() {
    var y;
    try {
      var raw = sessionStorage.getItem(CIW_RESET_SCROLL_KEY);
      if (raw === null) return;
      sessionStorage.removeItem(CIW_RESET_SCROLL_KEY);
      y = parseInt(raw, 10);
      if (!Number.isFinite(y) || y < 0) return;
    } catch (err) {
      return;
    }

    var scrollToY = function () {
      window.scrollTo(0, y);
    };

    if (document.readyState === 'complete') {
      requestAnimationFrame(scrollToY);
    } else {
      window.addEventListener('load', function () {
        requestAnimationFrame(scrollToY);
      }, { once: true });
    }
  }

  /* --- Sticky toolbar --- */
  function isMobileToolbarContext() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getToolbar() {
    return document.querySelector('.ciw-grid-toolbar');
  }

  var toolbarScrollRaf = null;
  var toolbarSpacerEl = null;
  var mobileToolbarStickScrollY = null;

  function resetMobileToolbarStickAnchor() {
    mobileToolbarStickScrollY = null;
  }

  function ensureToolbarSpacer(toolbar) {
    if (!toolbar) return null;
    if (toolbarSpacerEl && toolbarSpacerEl.previousElementSibling === toolbar) {
      return toolbarSpacerEl;
    }
    toolbarSpacerEl = document.createElement('div');
    toolbarSpacerEl.className = 'ciw-grid-toolbar-spacer';
    toolbarSpacerEl.setAttribute('aria-hidden', 'true');
    toolbar.insertAdjacentElement('afterend', toolbarSpacerEl);
    return toolbarSpacerEl;
  }

  function measureSiteHeaderOffset() {
    var ann = document.querySelector('.shopify-section-group-header-group.section-hp-announcement-rotator');
    var header = document.querySelector('.shopify-section-group-header-group.section-header');
    var offset = 0;
    if (ann) {
      var annBottom = ann.getBoundingClientRect().bottom;
      if (annBottom > 0) offset = Math.max(offset, annBottom);
    }
    if (header) {
      var headerBottom = header.getBoundingClientRect().bottom;
      if (headerBottom > 0) offset = Math.max(offset, headerBottom);
    }
    offset = Math.round(Math.max(0, offset));
    document.documentElement.style.setProperty('--ciw-site-header-offset', offset + 'px');
    return offset;
  }

  function getSiteHeaderOffset() {
    if (isMobileToolbarContext()) {
      return measureSiteHeaderOffset() || 90;
    }
    var n = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ciw-site-header-offset'));
    return Number.isFinite(n) && n > 0 ? n : measureSiteHeaderOffset() || 96;
  }

  function syncStickyBarHeight() {
    var toolbar = getToolbar();
    if (!toolbar) return;
    document.documentElement.style.setProperty('--ciw-sticky-bar-height', toolbar.offsetHeight + 'px');
  }

  function syncFilterHeaderHeight() {
    if (isMobileToolbarContext()) return;
    if (window.matchMedia('(min-width: 750px)').matches && document.getElementById('ciw-plp-filter-shell')) {
      return;
    }
    var toolbar = getToolbar();
    var filterBlock = document.querySelector('.facets-vertical .active-facets-vertical-filter');
    if (!toolbar || !filterBlock || !toolbar.classList.contains('is-stuck')) return;
    var toolbarRect = toolbar.getBoundingClientRect();
    var filterTop = filterBlock.getBoundingClientRect().top;
    var targetHeight = Math.round(toolbarRect.bottom - filterTop);
    if (targetHeight > 0) {
      document.documentElement.style.setProperty('--ciw-filter-header-height', targetHeight + 'px');
    }
  }

  function clearStickyMetrics() {
    document.documentElement.style.removeProperty('--ciw-sticky-bar-height');
    document.documentElement.style.removeProperty('--ciw-filter-header-height');
  }

  function applyStuckMetrics() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        syncStickyBarHeight();
        syncFilterHeaderHeight();
      });
    });
  }

  function syncMobileToolbarPin(toolbar, stuck) {
    if (!toolbar) return;
    if (!isMobileToolbarContext()) {
      toolbar.classList.remove('ciw-grid-toolbar--pinned');
      if (toolbarSpacerEl) toolbarSpacerEl.style.height = '0px';
      return;
    }

    var spacer = ensureToolbarSpacer(toolbar);
    toolbar.classList.toggle('ciw-grid-toolbar--pinned', stuck);
    if (stuck && spacer) {
      syncStickyBarHeight();
      spacer.style.height = toolbar.offsetHeight + 'px';
    } else if (spacer) {
      spacer.style.height = '0px';
    }
  }

  function checkStuck() {
    var toolbar = getToolbar();
    if (!toolbar) return;
    var offset = getSiteHeaderOffset();
    var stuck = false;
    var wasStuck = toolbar.classList.contains('is-stuck');

    if (isMobileToolbarContext()) {
      if (mobileToolbarStickScrollY !== null) {
        stuck = window.scrollY >= mobileToolbarStickScrollY - 1;
      } else {
        stuck = toolbar.getBoundingClientRect().top <= offset + 1;
      }

      if (stuck && mobileToolbarStickScrollY === null) {
        mobileToolbarStickScrollY = Math.max(0, window.scrollY);
      } else if (!stuck) {
        mobileToolbarStickScrollY = null;
      }
    } else {
      resetMobileToolbarStickAnchor();
      stuck = toolbar.getBoundingClientRect().top <= offset;
    }

    toolbar.classList.toggle('is-stuck', stuck);
    document.body.classList.toggle('ciw-toolbar-is-stuck', stuck);
    syncMobileToolbarPin(toolbar, stuck);
    if (stuck) {
      applyStuckMetrics();
    } else if (wasStuck) {
      clearStickyMetrics();
    }
  }

  function onToolbarScroll() {
    if (toolbarScrollRaf) return;
    toolbarScrollRaf = requestAnimationFrame(function () {
      toolbarScrollRaf = null;
      checkStuck();
    });
  }

  function remeasureToolbar() {
    measureSiteHeaderOffset();
    if (!isMobileToolbarContext()) {
      resetMobileToolbarStickAnchor();
    }
    checkStuck();
    var toolbar = getToolbar();
    if (toolbar && toolbar.classList.contains('is-stuck')) {
      applyStuckMetrics();
    }
  }

  window.ciwInitCollectionToolbar = remeasureToolbar;
  clearGridLoadingArtifacts();
  restorePreservedCollectionScroll();
  remeasureToolbar();
  window.addEventListener('scroll', onToolbarScroll, { passive: true });
  window.addEventListener('resize', remeasureToolbar);
  window.addEventListener('load', remeasureToolbar);
  document.addEventListener('ciw:collection-updated', function () {
    resetMobileToolbarStickAnchor();
    remeasureToolbar();
  });

  if (typeof MutationObserver !== 'undefined') {
    var stickyHeaderEl = document.querySelector('.shopify-section-group-header-group.section-header');
    if (stickyHeaderEl) {
      new MutationObserver(function () {
        if (!isMobileToolbarContext()) return;
        measureSiteHeaderOffset();
        checkStuck();
      }).observe(stickyHeaderEl, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (typeof ResizeObserver !== 'undefined') {
    var ro = new ResizeObserver(remeasureToolbar);
    var ann = document.querySelector('.shopify-section-group-header-group.section-hp-announcement-rotator');
    var header = document.querySelector('.shopify-section-group-header-group.section-header');
    var toolbarEl = getToolbar();
    if (ann) ro.observe(ann);
    if (header) ro.observe(header);
    if (toolbarEl) ro.observe(toolbarEl);
  }

  function getShapePillSlug(link) {
    if (!link) return '';
    var slug = String(link.getAttribute('data-ciw-pill-shape-slug') || '').toLowerCase();
    if (!slug) {
      slug = String(link.getAttribute('data-ciw-pill-shape') || '').toLowerCase();
    }
    return slug;
  }

  function getShapePillFamilyValues(linkOrSlug) {
    var slug = '';
    if (typeof linkOrSlug === 'string') {
      slug = linkOrSlug.toLowerCase();
    } else if (linkOrSlug && linkOrSlug.getAttribute) {
      var raw = linkOrSlug.getAttribute('data-ciw-pill-shape-values');
      if (raw) {
        return raw.split('|').map(function (value) {
          return value.trim();
        }).filter(Boolean);
      }
      slug = getShapePillSlug(linkOrSlug);
    }
    if (slug === 'rectangle') {
      return [
        'Rectangle',
        'Rectangular',
        'Rectangular-Square',
        'Rectangular/ Squared',
        'Square, Rectangular/ Squared',
        'Square',
      ];
    }
    if (slug === 'round') return ['Round'];
    return [];
  }

  function stripShapeSearchParams(params) {
    var keys = [];
    params.forEach(function (_, key) {
      if (key.toLowerCase().indexOf('shape') === -1) return;
      if (keys.indexOf(key) === -1) keys.push(key);
    });
    keys.forEach(function (key) {
      params.delete(key);
    });
    params.delete('ciw_shape_group');
  }

  function normalizeShapeToken(value) {
    return String(value || '').toLowerCase().trim();
  }

  var CIW_CAT_EYE_SHAPE_TOKENS = [
    'cat eye',
    'semi cat eye',
    'semi-cat eye',
    'round, semi-cat eye',
  ];

  function isCatEyeShapeToken(shape) {
    return CIW_CAT_EYE_SHAPE_TOKENS.indexOf(normalizeShapeToken(shape)) !== -1;
  }

  function cardMatchesShapeFamily(card, family, groupSlug) {
    var shape = normalizeShapeToken(card.getAttribute('data-ciw-frame-shape'));
    if (!shape || !family.length) return false;
    if (groupSlug === 'round' && isCatEyeShapeToken(shape)) return false;
    return family.some(function (value) {
      return shape === normalizeShapeToken(value);
    });
  }

  function isShapeNavPillActive(link) {
    var slug = getShapePillSlug(link);
    if (!slug) return false;
    var activeSlug = new URLSearchParams(window.location.search).get(CIW_SHAPE_GROUP_PARAM);
    if (activeSlug) {
      return normalizeShapeToken(activeSlug) === normalizeShapeToken(slug);
    }
    return false;
  }

  function ciwBuildShopAllShapeFilterHref(link, deactivate) {
    var params = new URLSearchParams(window.location.search);
    stripShapeSearchParams(params);

    if (!deactivate) {
      var slug = getShapePillSlug(link);
      if (slug) params.set(CIW_SHAPE_GROUP_PARAM, slug);
      if (slug === 'round') {
        params.set('filter.v.m.custom.shape', 'Round');
      }
    }

    if (!params.has('filter.v.availability')) {
      params.set('filter.v.availability', '1');
    }

    var previewId = ciwGetPreviewThemeId();
    if (previewId && !params.has('preview_theme_id')) {
      params.set('preview_theme_id', previewId);
    }

    return getEyeglassesShopAllPath() + '?' + params.toString();
  }

  function ciwTryMobileShopAllShapePill(navPill) {
    if (!ciwIsMobileCollectionView() || !isShopAllEyeglassesPath()) return false;
    if (navPill.getAttribute('data-ciw-pill-kind') !== 'shape') return false;

    var pillActive = navPill.closest('.ciw-collection-cat-pills__item--active');
    if (pillActive) {
      preserveScrollForCollectionReset();
    }

    var shapeHref = ciwBuildShopAllShapeFilterHref(navPill, pillActive);
    if (renderFromFacetFilters(shapeHref)) {
      syncCollectionNavPills();
      applyEyeglassesShapeGroupFilter();
      return true;
    }
    return false;
  }

  function isGenderNavPillActive(gender) {
    var params = new URLSearchParams(window.location.search);
    var target = String(gender || '').toLowerCase();
    var match = false;

    params.forEach(function (value, key) {
      if (match) return;
      if (key.toLowerCase().indexOf('gender') === -1) return;
      if (String(value).toLowerCase() === target) match = true;
    });

    return match;
  }

  function isShopAllEyeglassesPath() {
    return normalizeCollectionPath(window.location.pathname) === normalizeCollectionPath(getEyeglassesShopAllPath());
  }

  function isVendorNavPillActive(vendor) {
    if (window.location.pathname === '/collections/ray-ban') return true;
    var params = new URLSearchParams(window.location.search);
    var target = String(vendor || '').toLowerCase();
    var match = false;

    params.forEach(function (value, key) {
      if (match) return;
      if (key.toLowerCase().indexOf('vendor') === -1) return;
      if (String(value).toLowerCase() === target) match = true;
    });

    return match;
  }

  var CIW_SALE_URL_PARAM = 'ciw_onsale';
  var CIW_SALE_HIDDEN_CLASS = 'ciw-card--sale-filter-hidden';
  var CIW_SHAPE_GROUP_PARAM = 'ciw_shape_group';
  var CIW_SHAPE_HIDDEN_CLASS = 'ciw-card--shape-group-hidden';

  function isEyeglassesSaleNavPillActive() {
    return new URLSearchParams(window.location.search).get(CIW_SALE_URL_PARAM) === '1';
  }

  function isSaleProductCard(card) {
    return Boolean(card && card.querySelector('.ciw-card__msrp'));
  }

  function updateEyeglassesSaleCounts(visibleCount) {
    if (!isEyeglassesSaleNavPillActive()) return;

    var countText = visibleCount + ' item' + (visibleCount === 1 ? '' : 's');
    var countDesktop = document.getElementById('CiwProductCount');
    var countMobile = document.getElementById('CiwProductCountMobile');
    var loadedCountEl = document.querySelector('[data-view-more-loaded]');
    var viewMoreWrap = document.querySelector('.ciw-view-more-wrap');

    if (countDesktop) countDesktop.textContent = countText;
    if (countMobile) countMobile.textContent = visibleCount + ' Items';
    if (loadedCountEl) loadedCountEl.textContent = String(visibleCount);
    if (viewMoreWrap) viewMoreWrap.setAttribute('data-total', String(visibleCount));
  }

  function shuffleEyeglassesSaleCards(grid) {
    var visibleCards = Array.from(
      grid.querySelectorAll('.ciw-card:not(.' + CIW_SALE_HIDDEN_CLASS + ')')
    );
    if (visibleCards.length < 2) return;

    for (var i = visibleCards.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = visibleCards[i];
      visibleCards[i] = visibleCards[j];
      visibleCards[j] = temp;
    }

    visibleCards.forEach(function (card) {
      grid.appendChild(card);
    });
  }

  function applyEyeglassesSaleFilter() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var active = isEyeglassesSaleNavPillActive();
    var visibleCount = 0;

    grid.querySelectorAll('.ciw-card').forEach(function (card) {
      var show = !active || isSaleProductCard(card);
      card.classList.toggle(CIW_SALE_HIDDEN_CLASS, !show);
      if (show) visibleCount += 1;
    });

    if (active) {
      shuffleEyeglassesSaleCards(grid);
    }

    updateEyeglassesSaleCounts(visibleCount);
  }

  function updateEyeglassesShapeGroupCounts(visibleCount) {
    if (!new URLSearchParams(window.location.search).get(CIW_SHAPE_GROUP_PARAM)) return;

    var countText = visibleCount + ' item' + (visibleCount === 1 ? '' : 's');
    var countDesktop = document.getElementById('CiwProductCount');
    var countMobile = document.getElementById('CiwProductCountMobile');
    var loadedCountEl = document.querySelector('[data-view-more-loaded]');
    var viewMoreWrap = document.querySelector('.ciw-view-more-wrap');

    if (countDesktop) countDesktop.textContent = countText;
    if (countMobile) countMobile.textContent = visibleCount + ' Items';
    if (loadedCountEl) loadedCountEl.textContent = String(visibleCount);
    if (viewMoreWrap) viewMoreWrap.setAttribute('data-total', String(visibleCount));
  }

  function applyEyeglassesShapeGroupFilter() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var groupSlug = new URLSearchParams(window.location.search).get(CIW_SHAPE_GROUP_PARAM);
    if (!groupSlug) {
      grid.querySelectorAll('.ciw-card').forEach(function (card) {
        card.classList.remove(CIW_SHAPE_HIDDEN_CLASS);
        card.style.removeProperty('display');
      });
      return;
    }

    var family = getShapePillFamilyValues(groupSlug);
    var visibleCount = 0;

    grid.querySelectorAll('.ciw-card').forEach(function (card) {
      var show = cardMatchesShapeFamily(card, family, groupSlug);
      card.classList.toggle(CIW_SHAPE_HIDDEN_CLASS, !show);
      if (show) {
        card.style.removeProperty('display');
        visibleCount += 1;
      } else {
        card.style.setProperty('display', 'none', 'important');
      }
    });

    updateEyeglassesShapeGroupCounts(visibleCount);
  }

  function getEyeglassesShopAllPath() {
    var grid = document.getElementById('product-grid');
    if (grid && grid.getAttribute('data-ciw-shop-all-url')) {
      return normalizeCollectionPath(grid.getAttribute('data-ciw-shop-all-url'));
    }
    return '/collections/eyeglasses';
  }

  function getEyeglassesSaleFilterUrl() {
    return getEyeglassesShopAllPath() + '?' + buildEyeglassesInPlacePillParams('sale', false);
  }

  function normalizeCollectionPath(pathname) {
    var path = String(pathname || '');
    if (path.length > 1 && path.charAt(path.length - 1) === '/') {
      return path.slice(0, -1);
    }
    return path;
  }

  function isCollectionNavPillActive(onHref, targetHandle) {
    var curPath = normalizeCollectionPath(window.location.pathname);
    if (targetHandle) {
      return curPath === '/collections/' + targetHandle;
    }
    if (!onHref) return false;
    var onPath = normalizeCollectionPath(new URL(onHref, window.location.origin).pathname);
    return curPath === onPath;
  }

  function getNavPillExclusiveId(link) {
    if (!link) return null;
    var kind = link.getAttribute('data-ciw-pill-kind');
    var onHref = link.getAttribute('data-ciw-pill-on') || '';
    if (kind === 'sale') return 'sale';
    if (kind === 'vendor' && String(link.getAttribute('data-ciw-pill-vendor') || '').toLowerCase() === 'ray-ban') {
      return 'rayban';
    }
    if (kind === 'collection') {
      if (onHref.indexOf('best-sellers') !== -1 || onHref.indexOf('bestsellers') !== -1) return 'bestsellers';
      if (onHref.indexOf('designer-glasses') !== -1) return 'designer';
    }
    return null;
  }

  function getEyeglassesToolbarActivePillId() {
    var path = normalizeCollectionPath(window.location.pathname);
    var params = new URLSearchParams(window.location.search);
    var shopAllPath = getEyeglassesShopAllPath();

    if (path === shopAllPath && params.get(CIW_SALE_URL_PARAM) === '1') {
      return 'sale';
    }

    var vendorActive = false;
    if (path === shopAllPath) {
      params.forEach(function (value, key) {
        if (vendorActive) return;
        if (key.toLowerCase().indexOf('vendor') === -1) return;
        if (String(value).toLowerCase() === 'ray-ban') vendorActive = true;
      });
    }
    if (vendorActive) {
      return 'rayban';
    }

    if (path === '/collections/best-sellers-eyeglasses' || path === '/collections/best-sellers' || path === '/collections/bestsellers') {
      return 'bestsellers';
    }
    if (path === '/collections/designer-glasses') {
      return 'designer';
    }
    if (path === '/collections/ray-ban') {
      return 'rayban';
    }

    return null;
  }

  function buildEyeglassesInPlacePillParams(pillId, deactivate) {
    var params = new URLSearchParams();
    params.set('filter.v.availability', '1');
    if (!deactivate) {
      if (pillId === 'sale') {
        params.set(CIW_SALE_URL_PARAM, '1');
      } else if (pillId === 'rayban') {
        params.set('filter.p.vendor', 'Ray-Ban');
      }
    }
    var previewId = ciwGetPreviewThemeId();
    if (previewId) {
      params.set('preview_theme_id', previewId);
    }
    return params.toString();
  }

  function ciwBuildShopAllGenderFilterHref(gender, deactivate) {
    var params = new URLSearchParams();
    params.set('filter.v.availability', '1');
    if (!deactivate && gender) {
      params.set('filter.p.m.custom.gender', gender);
    }
    var previewId = ciwGetPreviewThemeId();
    if (previewId) {
      params.set('preview_theme_id', previewId);
    }
    return getEyeglassesShopAllPath() + '?' + params.toString();
  }

  function ciwTryMobileShopAllGenderPill(navPill, navTarget) {
    if (!ciwIsMobileCollectionView() || !isShopAllEyeglassesPath()) return false;

    var pillActive =
      navPill.classList.contains('ciw-cat-pill--active') ||
      navPill.closest('.ciw-collection-cat-pills__item--active');
    var gender = navPill.getAttribute('data-ciw-pill-gender');
    var pillKind = navPill.getAttribute('data-ciw-pill-kind');

    if (!gender && navTarget.pathname === '/collections/womens-glasses') {
      gender = 'Women';
    } else if (!gender && navTarget.pathname === '/collections/mens-glasses') {
      gender = 'Men';
    }

    if (pillKind !== 'gender' && !gender) return false;

    if (pillActive) {
      preserveScrollForCollectionReset();
    }

    var genderHref = ciwBuildShopAllGenderFilterHref(gender, pillActive);
    if (renderFromFacetFilters(genderHref)) {
      syncCollectionNavPills();
      return true;
    }
    return false;
  }

  function navigateEyeglassesInPlacePill(pillId, deactivate) {
    var path = getEyeglassesShopAllPath();
    var search = buildEyeglassesInPlacePillParams(pillId, deactivate);

    if (normalizeCollectionPath(path) !== normalizeCollectionPath(window.location.pathname)) {
      window.location.assign(path + '?' + search);
      return;
    }

    if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderPage === 'function') {
      FacetFiltersForm.renderPage(search);
      return;
    }

    history.replaceState({}, '', path + '?' + search);
    applyEyeglassesSaleFilter();
    syncCollectionNavPills();
  }

  function getNavPillGenderLabel(link) {
    if (!link) return '';
    var gender = link.getAttribute('data-ciw-pill-gender');
    if (gender) return gender;
    if (link.getAttribute('data-ciw-pill-kind') !== 'collection') return '';
    var onHref = link.getAttribute('data-ciw-pill-on') || link.getAttribute('href') || '';
    if (onHref.indexOf('womens-glasses') !== -1 || onHref.indexOf('womens-eyeglasses') !== -1) {
      return 'Women';
    }
    if (onHref.indexOf('mens-glasses') !== -1 || onHref.indexOf('mens-eyeglasses') !== -1) {
      return 'Men';
    }
    return '';
  }

  function isNavGenderPill(link, kind, genderLabel) {
    return kind === 'gender' || (kind === 'collection' && !!genderLabel);
  }

  function syncCollectionNavPills() {
    var exclusiveWinner = null;
    if (document.querySelector('.ciw-cat-pill[data-ciw-nav-pill]')) {
      exclusiveWinner = getEyeglassesToolbarActivePillId();
    }

    document.querySelectorAll('[data-ciw-nav-pill]').forEach(function (link) {
      var onHref = link.getAttribute('data-ciw-pill-on');
      var offHref = link.getAttribute('data-ciw-pill-off');
      var kind = link.getAttribute('data-ciw-pill-kind');
      var genderLabel = getNavPillGenderLabel(link);
      var active = false;
      var pillId = getNavPillExclusiveId(link);

      if ((!onHref || !offHref) && !genderLabel && kind !== 'shape' && kind !== 'sale') {
        return;
      }

      if (pillId && link.classList.contains('ciw-cat-pill')) {
        active = exclusiveWinner === pillId;
      } else if (isNavGenderPill(link, kind, genderLabel) && isShopAllEyeglassesPath()) {
        active = isGenderNavPillActive(
          link.getAttribute('data-ciw-pill-gender') || genderLabel
        );
      } else if (kind === 'shape') {
        active = isShapeNavPillActive(link);
      } else if (kind === 'vendor') {
        active = isVendorNavPillActive(link.getAttribute('data-ciw-pill-vendor'));
      } else if (kind === 'sale') {
        active = isEyeglassesSaleNavPillActive();
      } else if (kind === 'collection') {
        active = isCollectionNavPillActive(
          onHref,
          link.getAttribute('data-ciw-pill-collection')
        );
      }

      if (isNavGenderPill(link, kind, genderLabel) && isShopAllEyeglassesPath()) {
        var pillGender = link.getAttribute('data-ciw-pill-gender') || genderLabel;
        link.href = active
          ? offHref || ciwBuildShopAllGenderFilterHref(pillGender, true)
          : onHref || ciwBuildShopAllGenderFilterHref(pillGender, false);
      } else if (kind === 'shape' && isShopAllEyeglassesPath()) {
        link.href = ciwBuildShopAllShapeFilterHref(link, active);
      } else if (onHref && offHref) {
        link.href = active ? offHref : onHref;
      }
      link.classList.toggle('ciw-cat-pill--active', active && link.classList.contains('ciw-cat-pill'));

      if (active) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }

      var item = link.closest('.ciw-collection-cat-pills__item');
      if (item) {
        item.classList.toggle('ciw-collection-cat-pills__item--active', active);
      }
      if (link.classList.contains('ciw-collection-cat-pills__link')) {
        link.classList.toggle('ciw-collection-cat-pills__link--active', active);
      }
    });
  }

  window.ciwSyncCollectionNavPills = syncCollectionNavPills;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCollectionNavPills);
    document.addEventListener('DOMContentLoaded', applyEyeglassesSaleFilter);
    document.addEventListener('DOMContentLoaded', applyEyeglassesShapeGroupFilter);
  } else {
    syncCollectionNavPills();
    applyEyeglassesSaleFilter();
    applyEyeglassesShapeGroupFilter();
  }

  document.addEventListener('ciw:collection-updated', syncCollectionNavPills);
  document.addEventListener('ciw:collection-updated', applyEyeglassesSaleFilter);
  document.addEventListener('ciw:collection-updated', applyEyeglassesShapeGroupFilter);

  /* --- Filter pills + facet links (single path via FacetFiltersForm) --- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('facet-remove')) return;

    var navPill = e.target.closest('[data-ciw-nav-pill]');
    if (navPill && navPill.href) {
      e.preventDefault();
      var navTarget = new URL(navPill.href, window.location.origin);
      var exclusivePillId = getNavPillExclusiveId(navPill);
      if (
        navTarget.pathname === '/collections/on-sale' ||
        navPill.getAttribute('data-ciw-pill-collection') === 'on-sale'
      ) {
        navigateEyeglassesInPlacePill('sale', false);
        return;
      }
      if (exclusivePillId === 'sale' || exclusivePillId === 'rayban') {
        var exclusiveActive =
          navPill.classList.contains('ciw-cat-pill--active') ||
          navPill.closest('.ciw-collection-cat-pills__item--active');
        if (exclusiveActive) {
          preserveScrollForCollectionReset();
        }
        navigateEyeglassesInPlacePill(exclusivePillId, exclusiveActive);
        return;
      }
      if (
        ciwTryMobileShopAllGenderPill(navPill, navTarget)
      ) {
        return;
      }
      if (ciwTryMobileShopAllShapePill(navPill)) {
        return;
      }
      if (navTarget.pathname === window.location.pathname && renderFromFacetFilters(navPill.href)) {
        return;
      }
      if (
        navPill.classList.contains('ciw-cat-pill--active') ||
        navPill.closest('.ciw-collection-cat-pills__item--active')
      ) {
        preserveScrollForCollectionReset();
      }
      window.location.assign(navPill.href);
      return;
    }

    var resetLink = e.target.closest('.ciw-filter-reset');
    if (resetLink && resetLink.href) {
      e.preventDefault();
      var resetTarget = new URL(resetLink.href, window.location.origin);
      if (
        resetTarget.pathname === window.location.pathname &&
        renderFromFacetFilters(resetLink.href)
      ) {
        return;
      }
      preserveScrollForCollectionReset();
      window.location.assign(resetLink.href);
      return;
    }

    if (e.target.closest('#CiwSortBy')) return;

    var facetLink = e.target.closest('.facets a[href], .facets__price a[href]');
    if (
      facetLink &&
      facetLink.href.indexOf(window.location.pathname) !== -1 &&
      !facetLink.closest('label') &&
      !e.target.closest('.facets__label')
    ) {
      e.preventDefault();
      if (!renderFromFacetFilters(facetLink.href)) {
        window.location.href = facetLink.href;
      }
    }
  });

  /* --- Sort (CiwSortBy) --- */
  function ciwIsNativeSortValue(value) {
    return (
      value === 'price-ascending' ||
      value === 'price-descending' ||
      value === 'title-ascending' ||
      value === 'title-descending'
    );
  }

  function ciwShouldFullPageNativeEyeglassesSort(sortValue) {
    if (!ciwIsNativeSortValue(sortValue)) return false;
    var grid = document.getElementById('product-grid');
    return Boolean(grid && grid.dataset.ciwEyeglassesPlp === 'true');
  }

  function ciwNavigateNativeEyeglassesSort(sortValue) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortValue);
    if (!url.searchParams.has('filter.v.availability')) {
      url.searchParams.set('filter.v.availability', '1');
    }
    ciwShowNativeSortPageOverlay();
    window.location.assign(url.href);
  }

  function initCiwSort() {
    var sortSelect = document.getElementById('CiwSortBy');
    if (!sortSelect || sortSelect.dataset.ciwSortBound === 'true') return;
    sortSelect.dataset.ciwSortBound = 'true';
    sortSelect.addEventListener('change', function () {
      if (ciwShouldFullPageNativeEyeglassesSort(sortSelect.value)) {
        ciwNavigateNativeEyeglassesSort(sortSelect.value);
        return;
      }
      if (typeof FacetFiltersForm !== 'undefined') {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', sortSelect.value);
        FacetFiltersForm.renderPage(params.toString());
        return;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.href;
    });
  }

  initCiwSort();
  document.addEventListener('ciw:collection-updated', initCiwSort);

  /* --- View angle toggle (front / angle product images) --- */
  function getCiwGridViewMode() {
    try {
      return sessionStorage.getItem('ciwGridView') === 'angle' ? 'angle' : 'front';
    } catch (e) {
      return 'front';
    }
  }

  function setCiwGridViewMode(mode) {
    try {
      sessionStorage.setItem('ciwGridView', mode);
    } catch (e) {}
  }

  function syncCiwGridView() {
    var grid = document.getElementById('product-grid');
    var wrap = document.querySelector('.ciw-view-toggle');
    if (!grid || !wrap) return;
    var isAngle = getCiwGridViewMode() === 'angle';
    grid.classList.toggle('ciw-grid--angle', isAngle);
    var btns = wrap.querySelectorAll('.ciw-view-toggle__btn');
    if (btns.length >= 2) {
      btns[0].classList.toggle('ciw-view-toggle__btn--active', !isAngle);
      btns[1].classList.toggle('ciw-view-toggle__btn--active', isAngle);
      btns[0].setAttribute('aria-pressed', String(!isAngle));
      btns[1].setAttribute('aria-pressed', String(isAngle));
    }
  }

  if (!window.ciwViewToggleInit) {
    window.ciwViewToggleInit = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ciw-view-toggle__btn');
      if (!btn) return;
      var wrap = btn.closest('.ciw-view-toggle');
      if (!wrap) return;
      var btns = wrap.querySelectorAll('.ciw-view-toggle__btn');
      var idx = Array.prototype.indexOf.call(btns, btn);
      if (idx === -1) return;
      setCiwGridViewMode(idx === 1 ? 'angle' : 'front');
      syncCiwGridView();
    });
  }

  syncCiwGridView();
  document.addEventListener('ciw:collection-updated', syncCiwGridView);

  /* --- Mobile grid columns (2-up / 1-up, LensDirect-style) --- */
  function getCiwMobileGridCols() {
    try {
      return sessionStorage.getItem('ciwMobileGridCols') === '1' ? '1' : '2';
    } catch (e) {
      return '2';
    }
  }

  function setCiwMobileGridCols(cols) {
    try {
      sessionStorage.setItem('ciwMobileGridCols', cols);
    } catch (e) {}
  }

  function syncCiwMobileGrid() {
    var grid = document.getElementById('product-grid');
    var wrap = document.querySelector('.ciw-mobile-grid-toggle');
    if (!grid || !wrap) return;
    var cols = getCiwMobileGridCols();
    grid.classList.toggle('ciw-grid--mobile-1', cols === '1');
    var btns = wrap.querySelectorAll('.ciw-mobile-grid-toggle__btn');
    btns.forEach(function (btn) {
      var active = btn.getAttribute('data-mobile-cols') === cols;
      btn.classList.toggle('ciw-mobile-grid-toggle__btn--active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
  }

  if (!window.ciwMobileGridToggleInit) {
    window.ciwMobileGridToggleInit = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ciw-mobile-grid-toggle__btn');
      if (!btn) return;
      var cols = btn.getAttribute('data-mobile-cols');
      if (!cols) return;
      setCiwMobileGridCols(cols);
      syncCiwMobileGrid();
    });
  }

  syncCiwMobileGrid();
  document.addEventListener('ciw:collection-updated', function () {
    resetViewMoreHandles();
    syncCiwMobileGrid();
    ciwSyncViewMoreHref();
    var grid = document.getElementById('product-grid');
    if (grid && grid.dataset.ciwEyeglassesShopAllSort !== 'true') {
      ciwSortGridByBrand(grid);
    }
  });

  document.addEventListener('ciw:shop-all-sort-complete', function () {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    ciwNormalizeMobileFrameCardVisibility(grid);
    ciwRevealAllDesktopFrameCards();
    updateViewMoreCount(grid);
  });

  /* --- View more (pagination) --- */
  function ciwIsBrandAzSort() {
    return document.documentElement.dataset.ciwBrandAz === '1';
  }

  function ciwSortGridByBrand(grid) {
    if (!grid || !ciwIsBrandAzSort()) return;
    if (grid.classList.contains('ciw-product-grid--ld-sort')) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.ciw-card'));
    cards.sort(function (a, b) {
      var va = (a.dataset.brandSort || a.dataset.vendor || '').toLowerCase();
      var vb = (b.dataset.brandSort || b.dataset.vendor || '').toLowerCase();
      if (va === vb) {
        return (a.dataset.handle || '').localeCompare(b.dataset.handle || '');
      }
      return va.localeCompare(vb);
    });
    cards.forEach(function (card) {
      grid.appendChild(card);
    });
  }

  function ciwIsFramePlpPage() {
    var grid = document.getElementById('product-grid');
    if (!grid || !grid.classList.contains('ciw-product-grid')) return false;
    if (grid.classList.contains('ciw-product-grid--contacts')) return false;
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.isContactsPlpPage()) return false;
    return true;
  }

  function countDisplayedGridCards(grid) {
    if (!grid) return 0;
    if (ciwIsMobileCollectionView() && ciwIsFramePlpPage()) {
      var cards = grid.querySelectorAll('.ciw-card');
      var visible = 0;
      cards.forEach(function (card, index) {
        if (index < VIEW_MORE_MOBILE_BATCH_TARGET || card.classList.contains('ciw-mobile-plp-shown')) {
          visible += 1;
        }
      });
      return visible;
    }
    return grid.querySelectorAll('.ciw-card').length;
  }

  function countActuallyVisibleCards(grid) {
    if (!grid) return 0;
    if (ciwIsMobileCollectionView() && ciwIsFramePlpPage()) {
      return countDisplayedGridCards(grid);
    }
    var visible = 0;
    grid.querySelectorAll('.ciw-card').forEach(function (card) {
      if (window.getComputedStyle(card).display !== 'none') {
        visible += 1;
      }
    });
    return visible;
  }

  function ciwNormalizeMobileFrameCardVisibility(grid) {
    if (!grid || !ciwIsMobileCollectionView() || !ciwIsFramePlpPage()) return;
    grid.querySelectorAll('.ciw-card').forEach(function (card, index) {
      if (index < VIEW_MORE_MOBILE_BATCH_TARGET || card.classList.contains('ciw-mobile-plp-shown')) {
        card.classList.remove('ciw-mobile-plp-hidden');
      } else {
        card.classList.add('ciw-mobile-plp-hidden');
      }
    });
  }

  function ciwRevealMobileFrameBatch(grid) {
    if (!grid) return 0;
    var cards = grid.querySelectorAll('.ciw-card');
    var hidden = [];
    cards.forEach(function (card, index) {
      if (index >= VIEW_MORE_MOBILE_BATCH_TARGET && !card.classList.contains('ciw-mobile-plp-shown')) {
        hidden.push(card);
      }
    });
    var toShow = Math.min(VIEW_MORE_MOBILE_BATCH_TARGET, hidden.length);
    for (var i = 0; i < toShow; i++) {
      hidden[i].classList.add('ciw-mobile-plp-shown');
    }
    return toShow;
  }

  var FRAME_PLP_MIN_MOBILE_CARDS = 12;
  var frameGridReadyRunning = false;

  function ciwEnsureMobileFrameGridReady() {
    if (!ciwIsMobileCollectionView() || !ciwIsFramePlpPage()) return Promise.resolve();

    var grid = document.getElementById('product-grid');
    if (!grid || frameGridReadyRunning) return Promise.resolve();

    var visible = countActuallyVisibleCards(grid);
    if (visible >= FRAME_PLP_MIN_MOBILE_CARDS) {
      updateViewMoreCount(grid);
      return Promise.resolve();
    }

    ciwRevealMobileFrameBatch(grid);
    updateViewMoreCount(grid);
    visible = countActuallyVisibleCards(grid);
    if (visible >= FRAME_PLP_MIN_MOBILE_CARDS) return Promise.resolve();

    var btn = document.querySelector('[data-view-more]');
    var href = btn && btn.getAttribute('href');
    if (!href) return Promise.resolve();

    frameGridReadyRunning = true;
    return loadViewMorePage(href, grid, btn, 0)
      .then(function () {
        ciwRevealMobileFrameBatch(grid);
        updateViewMoreCount(grid);
      })
      .catch(function () {
        /* keep whatever SSR already rendered */
      })
      .finally(function () {
        frameGridReadyRunning = false;
      });
  }

  function updateViewMoreCount(grid) {
    var wrap = document.querySelector('.ciw-view-more-wrap');
    if (!wrap || !grid) return;
    var loadedEl = wrap.querySelector('[data-view-more-loaded]');
    var total = wrap.dataset.total || '';
    if (!total) {
      var countEl = wrap.querySelector('[data-view-more-count]');
      if (countEl && countEl.dataset.total) total = countEl.dataset.total;
    }
    var loaded = countDisplayedGridCards(grid);
    if (loadedEl) {
      loadedEl.textContent = String(loaded);
    }
    if (total) {
      wrap.dataset.total = String(total);
    }
  }

  window.ciwUpdateViewMoreCount = updateViewMoreCount;

  var viewMoreSeenHandles = null;

  function getLiveProductGrid() {
    return document.getElementById('product-grid');
  }

  function resetViewMoreHandles() {
    viewMoreSeenHandles = null;
  }

  function resetShopAllPrefetchState() {
    shopAllGridReadyRunning = false;
    shopAllGridReadyRunToken += 1;
    viewMoreSeenHandles = null;
    window.ciwShopAllSortPrefetchComplete = false;
    window.ciwShopAllSettledCount = 0;
  }

  window.ciwShopAllResetPrefetchState = resetShopAllPrefetchState;

  function getViewMoreCardKey(card) {
    return card.dataset.ciwCardKey || card.dataset.handle || '';
  }

  function ensureViewMoreHandles(grid) {
    if (viewMoreSeenHandles) return viewMoreSeenHandles;
    viewMoreSeenHandles = new Set(
      Array.prototype.map.call(grid.querySelectorAll('.ciw-card'), function (card) {
        return getViewMoreCardKey(card);
      }).filter(Boolean)
    );
    return viewMoreSeenHandles;
  }

  function ciwAdvancePaginationHref(href, pageStep) {
    pageStep = pageStep || 1;
    var url = new URL(ciwMergeCollectionParamsIntoUrl(href), window.location.origin);
    var page = parseInt(url.searchParams.get('page') || '1', 10);
    if (!Number.isFinite(page) || page < 1) page = 1;
    url.searchParams.set('page', String(page + pageStep));
    return url.pathname + url.search;
  }

  function ciwPaginationPageNum(href) {
    if (!href) return 1;
    var page = parseInt(new URL(ciwMergeCollectionParamsIntoUrl(href), window.location.origin).searchParams.get('page') || '1', 10);
    return Number.isFinite(page) && page > 0 ? page : 1;
  }

  function ciwResolveViewMoreFollowHref(currentHref, doc, addedOnPage) {
    if (ciwIsShopAllSortGrid()) {
      var wrap = document.querySelector('.ciw-view-more-wrap');
      var total = wrap ? parseInt(wrap.dataset.total || '0', 10) : 0;
      var loaded = countDisplayedGridCards(document.getElementById('product-grid'));
      if (total > 0 && loaded >= total) return '';

      var shopAllAdvanced = ciwAdvancePaginationHref(currentHref);
      var normalizedCurrent = ciwMergeCollectionParamsIntoUrl(currentHref);
      return shopAllAdvanced === normalizedCurrent ? '' : shopAllAdvanced;
    }

    var normalizedCurrent = ciwMergeCollectionParamsIntoUrl(currentHref);
    var followHref = getViewMoreNextHref(doc);
    var normalizedFollow = ciwMergeCollectionParamsIntoUrl(followHref);

    if (normalizedFollow && normalizedFollow !== normalizedCurrent) {
      return normalizedFollow;
    }

    if (addedOnPage === 0) {
      return '';
    }

    var advanced = ciwAdvancePaginationHref(currentHref);
    return advanced === normalizedCurrent ? '' : advanced;
  }

  function ciwIsMobileCollectionView() {
    return (
      window.matchMedia('(max-width: 749px)').matches &&
      document.body.classList.contains('template-collection')
    );
  }

  var CIW_PREVIEW_THEME_KEY = 'ciw_preview_theme_id';

  function ciwPersistPreviewThemeId() {
    try {
      var previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewId) {
        sessionStorage.setItem(CIW_PREVIEW_THEME_KEY, previewId);
      }
    } catch (err) {
      /* ignore */
    }
  }

  function ciwGetPreviewThemeId() {
    try {
      var fromUrl = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (fromUrl) return fromUrl;
      var fromStore = sessionStorage.getItem(CIW_PREVIEW_THEME_KEY);
      if (fromStore) return fromStore;
    } catch (err) {
      /* ignore */
    }
    var grid = document.getElementById('product-grid');
    if (grid && grid.dataset.ciwPreviewThemeId) {
      return grid.dataset.ciwPreviewThemeId;
    }
    return '';
  }

  function ciwMergeCollectionParamsIntoUrl(href) {
    if (!href) return href;
    var merged = new URL(href, window.location.origin);
    var active = new URLSearchParams(window.location.search);
    var keysToReplace = [];
    active.forEach(function (_value, key) {
      if (key === 'section_id' || key === 'page') return;
      if (keysToReplace.indexOf(key) === -1) keysToReplace.push(key);
    });
    keysToReplace.forEach(function (key) {
      merged.searchParams.delete(key);
    });
    active.forEach(function (value, key) {
      if (key === 'section_id' || key === 'page') return;
      merged.searchParams.append(key, value);
    });
    var previewId = ciwGetPreviewThemeId();
    if (previewId && !merged.searchParams.get('preview_theme_id')) {
      merged.searchParams.set('preview_theme_id', previewId);
    }
    var page = new URL(href, window.location.origin).searchParams.get('page');
    if (page) merged.searchParams.set('page', page);
    return merged.pathname + merged.search;
  }

  function ciwSyncViewMoreHref() {
    var wrap = document.querySelector('.ciw-view-more-wrap');
    if (!wrap) return;
    var btn = wrap.querySelector('[data-view-more]');
    var rawNext = (btn && btn.getAttribute('href')) || wrap.dataset.nextPage || '';
    if (!rawNext) return;
    var synced = ciwMergeCollectionParamsIntoUrl(rawNext);
    if (btn) btn.setAttribute('href', synced);
    wrap.dataset.nextPage = synced;
  }

  window.ciwSyncViewMoreHref = ciwSyncViewMoreHref;
  window.ciwSyncMobileViewMoreHref = ciwSyncViewMoreHref;

  function buildViewMoreFetchUrl(nextHref) {
    var merged = ciwMergeCollectionParamsIntoUrl(nextHref);
    var url = new URL(merged, window.location.origin);
    var previewId = ciwGetPreviewThemeId();
    if (previewId) {
      url.searchParams.set('preview_theme_id', previewId);
    }
    var grid = document.getElementById('product-grid');
    if (grid && grid.dataset.id) {
      url.searchParams.set('section_id', grid.dataset.id);
    }
    return url.pathname + url.search;
  }

  function getFetchedProductGrid(doc) {
    if (!doc) return null;
    var fetchedGrid = doc.getElementById('product-grid');
    if (fetchedGrid) return fetchedGrid;
    var container = doc.getElementById('ProductGridContainer');
    if (container) {
      return container.querySelector('#product-grid, .ciw-product-grid');
    }
    return doc.querySelector('.ciw-product-grid');
  }

  function parseFetchedGridFromHtml(html) {
    if (!html || html.indexOf('ciw-card') === -1) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var grid = getFetchedProductGrid(doc);
    if (grid) return grid;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.querySelector('#product-grid, .ciw-product-grid');
  }

  function appendViewMoreCards(fetchedGrid, grid) {
    return appendFetchedGridCards(fetchedGrid, grid, { sort: true });
  }

  var viewMoreLoading = false;
  var shopAllGridReadyRunning = false;
  var shopAllGridReadyRunToken = 0;

  var VIEW_MORE_BATCH_TARGET = 60;
  var VIEW_MORE_MOBILE_BATCH_TARGET = 12;
  var VIEW_MORE_MAX_PAGES_PER_CLICK = 100;
  var VIEW_MORE_FETCH_MAX_RETRIES = 2;
  var SHOP_ALL_VIEW_MORE_CARDS_TARGET = 36;
  var SHOP_ALL_VIEW_MORE_MAX_PAGES = 25;
  var SHOP_ALL_VIEW_MORE_FETCH_DELAY_MS = 60;
  var SHOP_ALL_VIEW_MORE_FLUSH_MIN = 8;
  var SHOP_ALL_VIEW_MORE_MAX_EMPTY_FETCHES = 6;
  var SHOP_ALL_NEXT_PAGE_KEY = 'ciw_shop_all_view_more_page';

  function ciwGetShopAllStoredNextPage() {
    try {
      var page = parseInt(sessionStorage.getItem(SHOP_ALL_NEXT_PAGE_KEY) || '0', 10);
      return Number.isFinite(page) && page > 1 ? page : 0;
    } catch (err) {
      return 0;
    }
  }

  function ciwStoreShopAllNextPage(href) {
    if (!href) return;
    try {
      sessionStorage.setItem(SHOP_ALL_NEXT_PAGE_KEY, String(ciwPaginationPageNum(href)));
    } catch (err) {
      /* ignore */
    }
  }

  function ciwClearShopAllStoredNextPage() {
    try {
      sessionStorage.removeItem(SHOP_ALL_NEXT_PAGE_KEY);
    } catch (err) {
      /* ignore */
    }
  }

  function ciwClearStaleShopAllStoredPage() {
    if (!ciwIsShopAllSortGrid()) return;
    var wrap = document.querySelector('.ciw-view-more-wrap');
    var btn = wrap && wrap.querySelector('[data-view-more]');
    if (!btn) return;
    var btnPage = ciwPaginationPageNum(btn.getAttribute('href'));
    var storedPage = ciwGetShopAllStoredNextPage();
    if (storedPage > btnPage + 1) {
      ciwClearShopAllStoredNextPage();
    }
  }

  function ciwShopAllViewMoreResetHref() {
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.set('page', '2');
    var previewId = ciwGetPreviewThemeId();
    if (previewId) {
      params.set('preview_theme_id', previewId);
    }
    return window.location.pathname + '?' + params.toString();
  }

  function ciwGetShopAllEmptyPageSkip(emptyStreak) {
    if (emptyStreak >= 3) return 5;
    if (emptyStreak >= 2) return 3;
    if (emptyStreak >= 1) return 2;
    return 1;
  }

  function ciwResolveShopAllViewMoreFollowHref(currentHref, grid, added, shopAllState) {
    var wrap = document.querySelector('.ciw-view-more-wrap');
    var total = wrap ? parseInt(wrap.dataset.total || '0', 10) : 0;
    var loaded = countDisplayedGridCards(grid);
    if (total > 0 && loaded >= total) return '';

    var pageSkip = 1;
    if (added === 0) {
      shopAllState.emptyStreak += 1;
      pageSkip = ciwGetShopAllEmptyPageSkip(shopAllState.emptyStreak);
    } else {
      shopAllState.emptyStreak = 0;
      ciwStoreShopAllNextPage(currentHref);
    }

    var followHref = ciwAdvancePaginationHref(currentHref, pageSkip);
    var normalizedCurrent = ciwMergeCollectionParamsIntoUrl(currentHref);
    if (added > 0 && followHref !== normalizedCurrent) {
      ciwStoreShopAllNextPage(followHref);
    }
    return followHref === normalizedCurrent ? '' : followHref;
  }

  function getViewMoreBatchTarget() {
    if (ciwIsShopAllSortGrid()) {
      return ciwIsMobileCollectionView() ? VIEW_MORE_MOBILE_BATCH_TARGET : SHOP_ALL_VIEW_MORE_CARDS_TARGET;
    }
    return ciwIsMobileCollectionView() ? VIEW_MORE_MOBILE_BATCH_TARGET : VIEW_MORE_BATCH_TARGET;
  }

  function getViewMoreMaxPagesPerClick() {
    if (ciwIsShopAllSortGrid()) {
      return SHOP_ALL_VIEW_MORE_MAX_PAGES;
    }
    return VIEW_MORE_MAX_PAGES_PER_CLICK;
  }

  function ciwIsShopAllSortGrid() {
    var grid = document.getElementById('product-grid');
    return Boolean(
      grid && grid.dataset.ciwEyeglassesShopAllSort === 'true' && !ciwIsNativeEyeglassesSort()
    );
  }

  function ciwIsNativeEyeglassesSort() {
    var sort = new URLSearchParams(window.location.search).get('sort_by');
    return (
      sort === 'price-ascending' ||
      sort === 'price-descending' ||
      sort === 'title-ascending' ||
      sort === 'title-descending'
    );
  }

  function ciwGetNativeSortMode() {
    if (!ciwIsNativeEyeglassesSort()) return '';
    return new URLSearchParams(window.location.search).get('sort_by') || '';
  }

  function ciwGetCardSortPrice(card) {
    var fromData = parseInt(card.dataset.ciwSortPrice || '', 10);
    if (Number.isFinite(fromData) && fromData > 0) return fromData;

    var priceEl = card.querySelector('.ciw-card__price');
    if (!priceEl) return 0;

    var matches = String(priceEl.textContent || '').match(/\d[\d,]*(?:\.\d{2})?/g) || [];
    var cents = matches
      .map(function (match) {
        var normalized = match.replace(/,/g, '');
        if (normalized.indexOf('.') !== -1) {
          return Math.round(parseFloat(normalized) * 100);
        }
        return parseInt(normalized, 10) * 100;
      })
      .filter(function (value) {
        return Number.isFinite(value) && value > 0;
      });

    return cents.length ? Math.min.apply(null, cents) : 0;
  }

  function ciwGetCardSortTitle(card) {
    var fromData = String(card.dataset.ciwSortTitle || '').trim();
    if (fromData) return fromData.toLowerCase();

    var titleEl = card.querySelector('.ciw-card__title');
    return String(titleEl ? titleEl.textContent : '')
      .trim()
      .toLowerCase();
  }

  function ciwApplyNativeEyeglassesSort(grid) {
    grid = grid && grid.isConnected ? grid : getLiveProductGrid();
    if (!grid) return;

    if (
      typeof FacetFiltersForm !== 'undefined' &&
      typeof FacetFiltersForm.applyNativeEyeglassesSort === 'function'
    ) {
      FacetFiltersForm.applyNativeEyeglassesSort(grid);
      return;
    }

    var sort = ciwGetNativeSortMode();
    if (!sort) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.ciw-card'));
    if (cards.length < 2) return;

    cards.forEach(function (card) {
      delete card.dataset.ciwSettled;
    });

    cards.sort(function (a, b) {
      if (sort === 'price-ascending' || sort === 'price-descending') {
        var priceA = ciwGetCardSortPrice(a);
        var priceB = ciwGetCardSortPrice(b);
        if (priceA !== priceB) {
          return sort === 'price-ascending' ? priceA - priceB : priceB - priceA;
        }
      } else {
        var titleA = ciwGetCardSortTitle(a);
        var titleB = ciwGetCardSortTitle(b);
        if (titleA !== titleB) {
          var cmp = titleA.localeCompare(titleB);
          return sort === 'title-descending' ? -cmp : cmp;
        }
      }

      return (a.dataset.handle || '').localeCompare(b.dataset.handle || '');
    });

    cards.forEach(function (card) {
      grid.appendChild(card);
    });
  }

  function ciwRevealNativeSortGridNow() {
    var grid = getLiveProductGrid();
    if (!grid) return;
    window.ciwShopAllSortPrefetchComplete = true;
    ciwHandoffBootSkeletonToGrid();
    var wrap = grid.closest('.ciw-product-grid-wrap');
    if (wrap) wrap.classList.remove('is-loading');
    ciwApplyNativeEyeglassesSort(grid);
    ciwRevealAllDesktopFrameCards();
    ciwNormalizeMobileFrameCardVisibility(grid);
    ciwRevealMobileFrameBatch(grid);
    updateViewMoreCount(grid);
    ciwSyncViewMoreHref();
    ciwHideNativeSortPageOverlay();
  }

  var SHOP_ALL_INIT_PREFETCH_MAX_PAGES = 8;
  var SHOP_ALL_VENDOR_FETCH_DELAY_MS = 220;
  var SHOP_ALL_VENDOR_FETCH_MAX_RETRIES = 3;
  var SHOP_ALL_VENDOR_PREFETCH = [
    'Ray-Ban',
    'Versace',
    'Gucci',
    'Tom Ford',
    'Prada',
    'Burberry',
    'Ralph Lauren',
    'Cazal',
    'Hugo',
    'Michael Kors',
  ];

  function ciwShopAllHasPriorityDesigners(grid) {
    if (!grid) return false;
    return Array.from(grid.querySelectorAll('.ciw-card')).some(function (card) {
      var brand = (card.dataset.brandSort || card.dataset.vendor || '').toLowerCase();
      return brand.indexOf('ray-ban') !== -1 || brand.indexOf('rayban') !== -1;
    });
  }

  function ciwShopAllHasVendor(grid, vendor) {
    if (!grid || !vendor) return false;
    var needle = String(vendor).toLowerCase();
    return Array.from(grid.querySelectorAll('.ciw-card')).some(function (card) {
      var brand = (card.dataset.brandSort || card.dataset.vendor || '').toLowerCase();
      return brand === needle || brand.indexOf(needle) !== -1;
    });
  }

  function buildShopAllVendorFetchUrl(vendor) {
    var grid = document.getElementById('product-grid');
    var params = new URLSearchParams(window.location.search);
    params.set('filter.v.availability', '1');
    params.delete('page');
    params.set('filter.p.vendor', vendor);
    if (grid && grid.dataset.id) {
      params.set('section_id', grid.dataset.id);
    }
    var previewId = ciwGetPreviewThemeId();
    if (previewId) {
      params.set('preview_theme_id', previewId);
    }
    return window.location.pathname + '?' + params.toString();
  }

  function appendFetchedGridCards(fetchedGrid, grid, options) {
    options = options || {};
    grid = grid && grid.isConnected ? grid : getLiveProductGrid();
    if (!grid || !fetchedGrid) return 0;
    var existingHandles = ensureViewMoreHandles(grid);
    var added = 0;
    var fragment = document.createDocumentFragment();
    fetchedGrid.querySelectorAll('.ciw-card').forEach(function (card) {
      var key = getViewMoreCardKey(card);
      if (key && existingHandles.has(key)) return;
      var imported = document.importNode(card, true);
      fragment.appendChild(imported);
      if (key) existingHandles.add(key);
      added += 1;
    });
    if (added > 0) {
      grid.appendChild(fragment);
    }
    if (added > 0 && options.sort !== false && !shopAllGridReadyRunning && !window.ciwViewMoreLoading) {
      if (ciwIsNativeEyeglassesSort()) {
        ciwApplyNativeEyeglassesSort(grid);
      } else if (
        grid.dataset.ciwEyeglassesShopAllSort === 'true' &&
        typeof window.ciwEyeglassesShopAllSortRun === 'function'
      ) {
        window.ciwEyeglassesShopAllSortRun();
      } else {
        ciwSortGridByBrand(grid);
      }
      ciwNormalizeMobileFrameCardVisibility(grid);
    }
    return added;
  }

  function ciwMarkShopAllSettledCards(grid) {
    if (!grid) return;
    grid.querySelectorAll('.ciw-card').forEach(function (card) {
      card.dataset.ciwSettled = 'true';
    });
  }

  function ciwCreateShopAllViewMoreState(grid) {
    var handleSet = new Set();
    if (grid) {
      grid.querySelectorAll('.ciw-card').forEach(function (card) {
        var key = getViewMoreCardKey(card);
        if (key) handleSet.add(key);
      });
    }
    return {
      emptyStreak: 0,
      failedFetchStreak: 0,
      fragment: document.createDocumentFragment(),
      handleSet: handleSet,
      pendingAdded: 0,
      flushedAdded: 0,
      didFirstFlush: false,
      settledCount: grid ? grid.querySelectorAll('.ciw-card').length : 0,
      prefetchHref: '',
      prefetchPromise: null,
    };
  }

  function ciwFlushShopAllViewMoreProgress(grid, shopAllState) {
    if (!grid || !shopAllState || !shopAllState.pendingAdded) return 0;
    var added = ciwAppendShopAllViewMoreBatch(grid, shopAllState);
    if (added > 0 && typeof window.ciwEyeglassesShopAllSortAppend === 'function') {
      window.ciwEyeglassesShopAllSortAppend(shopAllState.settledCount);
      shopAllState.settledCount = grid.querySelectorAll('.ciw-card').length;
    }
    shopAllState.flushedAdded += added;
    return added;
  }

  function ciwTakeShopAllViewMorePrefetch(shopAllState, href) {
    if (!shopAllState || shopAllState.prefetchHref !== href || !shopAllState.prefetchPromise) {
      return null;
    }
    var promise = shopAllState.prefetchPromise;
    shopAllState.prefetchHref = '';
    shopAllState.prefetchPromise = null;
    return promise;
  }

  function ciwQueueShopAllViewMorePrefetch(shopAllState, href) {
    if (!shopAllState || !href || shopAllState.prefetchHref === href) return;
    shopAllState.prefetchHref = href;
    shopAllState.prefetchPromise = fetchShopAllViewMoreHtml(href);
  }

  function collectFetchedGridCards(fetchedGrid, shopAllState) {
    if (!fetchedGrid || !shopAllState) return 0;
    var added = 0;
    fetchedGrid.querySelectorAll('.ciw-card').forEach(function (card) {
      var key = getViewMoreCardKey(card);
      if (key && shopAllState.handleSet.has(key)) return;
      var imported = document.importNode(card, true);
      imported.removeAttribute('data-ciw-settled');
      shopAllState.fragment.appendChild(imported);
      if (key) shopAllState.handleSet.add(key);
      added += 1;
    });
    shopAllState.pendingAdded += added;
    return added;
  }

  function ciwAppendShopAllViewMoreBatch(grid, shopAllState) {
    if (!grid || !shopAllState || !shopAllState.fragment.childNodes.length) return 0;
    var added = shopAllState.pendingAdded;
    grid.appendChild(shopAllState.fragment);
    shopAllState.pendingAdded = 0;
    return added;
  }

  function loadViewMorePageSingle(nextHref, grid, triggerBtn, options) {
    options = options || {};
    return fetch(buildViewMoreFetchUrl(nextHref))
      .then(function (r) {
        if (!r.ok) throw new Error('View more failed');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fetchedGrid = getFetchedProductGrid(doc);
        if (!fetchedGrid) throw new Error('Product grid missing');
        var added = appendFetchedGridCards(fetchedGrid, grid, { sort: options.sort });
        if (options.syncViewMore !== false) {
          syncViewMoreButton(doc, triggerBtn, nextHref);
        }
        return added;
      });
  }

  function ciwDelay(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function ciwShopAllFetchVendorCards(vendor, grid, attempt) {
    attempt = attempt || 0;
    var liveGrid = grid && grid.isConnected ? grid : getLiveProductGrid();
    if (!liveGrid) return Promise.resolve(0);

    return fetch(buildShopAllVendorFetchUrl(vendor))
      .then(function (r) {
        if (r.status === 429 && attempt < SHOP_ALL_VENDOR_FETCH_MAX_RETRIES) {
          return ciwDelay(700 * (attempt + 1)).then(function () {
            return ciwShopAllFetchVendorCards(vendor, liveGrid, attempt + 1);
          });
        }
        if (!r.ok) throw new Error('Vendor prefetch failed');
        return r.text();
      })
      .then(function (html) {
        if (typeof html !== 'string') return html;
        var currentGrid = grid && grid.isConnected ? grid : getLiveProductGrid();
        if (!currentGrid) return 0;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fetchedGrid = getFetchedProductGrid(doc);
        if (!fetchedGrid) return 0;
        return appendFetchedGridCards(fetchedGrid, currentGrid, { sort: false });
      })
      .catch(function () {
        return 0;
      });
  }

  function ciwShopAllPrefetchPriorityVendors(grid, options) {
    options = options || {};
    var vendors = SHOP_ALL_VENDOR_PREFETCH.filter(function (vendor) {
      var liveGrid = grid && grid.isConnected ? grid : getLiveProductGrid();
      return liveGrid && !ciwShopAllHasVendor(liveGrid, vendor);
    });
    if (options.requiredVendor) {
      vendors = vendors.filter(function (vendor) {
        return vendor === options.requiredVendor;
      });
    } else if (options.skipVendor) {
      vendors = vendors.filter(function (vendor) {
        return vendor !== options.skipVendor;
      });
    }
    if (!vendors.length) return Promise.resolve();

    return vendors.reduce(function (chain, vendor) {
      return chain
        .then(function () {
          return ciwDelay(SHOP_ALL_VENDOR_FETCH_DELAY_MS);
        })
        .then(function () {
          return ciwShopAllFetchVendorCards(vendor, grid);
        });
    }, Promise.resolve());
  }

  function ciwShopAllPrefetchForInitialSort(grid, runToken) {
    if (ciwShopAllHasPriorityDesigners(grid)) {
      if (runToken != null && runToken !== shopAllGridReadyRunToken) return Promise.resolve();
      if (!getLiveProductGrid()) return Promise.resolve();
      ciwRevealShopAllGridNow();
      return Promise.resolve();
    }

    return ciwShopAllPrefetchPriorityVendors(grid, { requiredVendor: 'Ray-Ban' })
      .then(function () {
        if (runToken != null && runToken !== shopAllGridReadyRunToken) return;
        if (!getLiveProductGrid()) return;
        ciwRevealShopAllGridNow();
      });
  }

  function ciwRevealShopAllGridNow() {
    var grid = getLiveProductGrid();
    if (!grid) return;
    window.ciwShopAllSortPrefetchComplete = true;
    window.ciwShopAllSettledCount = 0;
    if (typeof window.ciwEyeglassesShopAllSortRun === 'function') {
      window.ciwEyeglassesShopAllSortRun();
    } else {
      var wrap = grid.closest('.ciw-product-grid-wrap');
      if (wrap) wrap.classList.remove('is-loading');
    }
    ciwRevealAllDesktopFrameCards();
    ciwNormalizeMobileFrameCardVisibility(grid);
    ciwRevealMobileFrameBatch(grid);
    updateViewMoreCount(grid);
    ciwSyncViewMoreHref();
  }

  function ciwEnsureShopAllFrameGridReady() {
    if (!ciwIsShopAllSortGrid()) return Promise.resolve();

    var params = new URLSearchParams(window.location.search);
    if (!params.has('filter.v.availability')) {
      return Promise.resolve();
    }

    if (typeof window.ciwShopAllPrepareGrid === 'function') {
      return window.ciwShopAllPrepareGrid();
    }
    return Promise.resolve();
  }

  window.ciwRevealNativeSortGridNow = ciwRevealNativeSortGridNow;
  window.ciwApplyNativeEyeglassesSort = ciwApplyNativeEyeglassesSort;

  window.ciwShopAllPrepareGrid = function () {
    if (!ciwIsShopAllSortGrid()) return Promise.resolve();

    if (ciwIsNativeEyeglassesSort()) {
      ciwRevealNativeSortGridNow();
      return Promise.resolve();
    }

    /* Never designer-boost when a real facet (shape/gender/etc.) is already in the URL. */
    var shopAllFacetParams = new URLSearchParams(window.location.search);
    var shopAllFacetActive = Boolean(shopAllFacetParams.get('ciw_shape_group'));
    if (!shopAllFacetActive) {
      shopAllFacetParams.forEach(function (value, key) {
        if (shopAllFacetActive) return;
        var normalizedKey = key.toLowerCase();
        if (
          (normalizedKey.indexOf('vendor') !== -1 ||
            normalizedKey.indexOf('gender') !== -1 ||
            normalizedKey.indexOf('shape') !== -1 ||
            normalizedKey.indexOf('frame_type') !== -1) &&
          String(value || '').trim()
        ) {
          shopAllFacetActive = true;
        }
      });
    }
    if (shopAllFacetActive) {
      var shopAllWrap = document.querySelector('.ciw-product-grid-wrap--shop-all-sort');
      if (shopAllWrap) shopAllWrap.classList.remove('is-loading');
      window.ciwShopAllSortPrefetchComplete = true;
      return Promise.resolve();
    }

    resetShopAllPrefetchState();

    var grid = getLiveProductGrid();
    if (!grid) return Promise.resolve();

    var wrap = grid.closest('.ciw-product-grid-wrap');
    if (wrap) wrap.classList.add('is-loading');

    var runToken = shopAllGridReadyRunToken;
    shopAllGridReadyRunning = true;
    return ciwShopAllPrefetchForInitialSort(grid, runToken).finally(function () {
      if (runToken === shopAllGridReadyRunToken) {
        shopAllGridReadyRunning = false;
        var settledGrid = getLiveProductGrid();
        if (settledGrid) {
          updateViewMoreCount(settledGrid);
          ciwSyncViewMoreHref();
        }
      }
    });
  };

  function getViewMoreNextHref(doc) {
    if (!doc) return '';
    var followBtn = doc.querySelector('[data-view-more]');
    var followWrap = doc.querySelector('.ciw-view-more-wrap');
    return (followBtn && followBtn.getAttribute('href')) || (followWrap && followWrap.dataset.nextPage) || '';
  }

  function syncViewMoreButton(doc, triggerBtn, fetchedFromHref, forcedNextHref) {
    var wrap = document.querySelector('.ciw-view-more-wrap');
    if (!wrap) return;

    var btn = wrap.querySelector('[data-view-more]') || triggerBtn;
    var newWrap = doc && doc.querySelector('.ciw-view-more-wrap');

    if (newWrap && newWrap.dataset.total) {
      wrap.dataset.total = newWrap.dataset.total;
    }

    if (ciwIsShopAllSortGrid() && fetchedFromHref && btn) {
      var loaded = countDisplayedGridCards(document.getElementById('product-grid'));
      var total = parseInt(wrap.dataset.total || '0', 10);

      if (total > 0 && loaded >= total) {
        wrap.remove();
        return;
      }

      var advanced = forcedNextHref
        ? ciwMergeCollectionParamsIntoUrl(forcedNextHref)
        : ciwMergeCollectionParamsIntoUrl(ciwAdvancePaginationHref(fetchedFromHref));
      btn.setAttribute('href', advanced);
      if (!window.ciwViewMoreLoading) {
        btn.textContent = 'View More';
        btn.style.pointerEvents = '';
      }
      wrap.dataset.nextPage = advanced;
      ciwSyncViewMoreHref();
      return;
    }

    var newBtn = doc && doc.querySelector('[data-view-more]');
    var nextHref = (newBtn && newBtn.getAttribute('href')) || (newWrap && newWrap.dataset.nextPage) || '';

    if (nextHref && btn) {
      btn.setAttribute('href', nextHref);
      btn.textContent = 'View More';
      btn.style.pointerEvents = '';
      if (newWrap && newWrap.dataset.nextPage) {
        wrap.dataset.nextPage = newWrap.dataset.nextPage;
      } else {
        delete wrap.dataset.nextPage;
      }
      ciwSyncViewMoreHref();
      return;
    }

    wrap.remove();
  }

  function fetchViewMoreHtml(nextHref, attempt) {
    attempt = attempt || 0;
    return fetch(buildViewMoreFetchUrl(nextHref)).then(function (r) {
      if ((r.status === 429 || r.status >= 500) && attempt < VIEW_MORE_FETCH_MAX_RETRIES) {
        return ciwDelay(500 * (attempt + 1)).then(function () {
          return fetchViewMoreHtml(nextHref, attempt + 1);
        });
      }
      if (!r.ok) throw new Error('View more failed: ' + r.status);
      return r.text();
    });
  }

  function fetchShopAllViewMoreHtml(nextHref, attempt) {
    attempt = attempt || 0;
    return fetchViewMoreHtml(nextHref, 0).catch(function () {
      if (attempt < VIEW_MORE_FETCH_MAX_RETRIES) {
        return ciwDelay(400 * (attempt + 1)).then(function () {
          return fetchShopAllViewMoreHtml(nextHref, attempt + 1);
        });
      }
      return '';
    });
  }

  function ciwMaybeRemoveViewMoreWrap(grid) {
    var wrap = document.querySelector('.ciw-view-more-wrap');
    if (!wrap || !grid) return;
    var total = parseInt(wrap.dataset.total || '0', 10);
    var loaded = countDisplayedGridCards(grid);
    if (total > 0 && loaded >= total) {
      wrap.remove();
    }
  }

  function loadViewMorePage(nextHref, grid, triggerBtn, depth, batchAdded, shopAllState) {
    depth = depth || 0;
    batchAdded = batchAdded || 0;
    if (!nextHref || depth >= getViewMoreMaxPagesPerClick()) {
      return Promise.resolve(batchAdded);
    }

    var fetchedFromHref = nextHref;
    var fetchPage = shopAllState
      ? function () {
          var prefetched = ciwTakeShopAllViewMorePrefetch(shopAllState, nextHref);
          if (prefetched) {
            return prefetched;
          }
          return ciwDelay(depth > 0 ? SHOP_ALL_VIEW_MORE_FETCH_DELAY_MS : 0).then(function () {
            return fetchShopAllViewMoreHtml(nextHref);
          });
        }
      : function () {
          return fetchViewMoreHtml(nextHref);
        };

    return fetchPage()
      .then(function (html) {
        var doc = null;
        var fetchedGrid = null;
        var added = 0;

        if (html) {
          doc = new DOMParser().parseFromString(html, 'text/html');
          fetchedGrid = parseFetchedGridFromHtml(html);
        }

        if (shopAllState) {
          if (!fetchedGrid) {
            shopAllState.failedFetchStreak += 1;
          } else {
            shopAllState.failedFetchStreak = 0;
          }
        }

        if (fetchedGrid) {
          added = shopAllState
            ? collectFetchedGridCards(fetchedGrid, shopAllState)
            : appendFetchedGridCards(fetchedGrid, grid, { sort: false });
        }

        batchAdded += added;

        if (shopAllState && shopAllState.pendingAdded > 0) {
          var shouldFlush =
            !shopAllState.didFirstFlush ||
            shopAllState.pendingAdded >= SHOP_ALL_VIEW_MORE_FLUSH_MIN ||
            batchAdded >= getViewMoreBatchTarget();
          if (shouldFlush) {
            var flushed = ciwFlushShopAllViewMoreProgress(grid, shopAllState);
            if (!shopAllState.didFirstFlush && flushed > 0) {
              shopAllState.didFirstFlush = true;
              var shopAllWrap = grid.closest('.ciw-product-grid-wrap--shop-all-sort');
              if (shopAllWrap) shopAllWrap.classList.remove('is-view-more-loading');
              updateViewMoreCount(grid);
            } else if (flushed > 0) {
              updateViewMoreCount(grid);
            }
          }
        }

        if (
          shopAllState &&
          shopAllState.failedFetchStreak >= SHOP_ALL_VIEW_MORE_MAX_EMPTY_FETCHES &&
          batchAdded === 0
        ) {
          return batchAdded;
        }

        var followHref = shopAllState
          ? ciwResolveShopAllViewMoreFollowHref(fetchedFromHref, grid, added, shopAllState)
          : ciwResolveViewMoreFollowHref(fetchedFromHref, doc, added);

        syncViewMoreButton(doc, triggerBtn, fetchedFromHref, shopAllState ? followHref : '');
        if (!shopAllState) {
          updateViewMoreCount(grid);
          ciwMaybeRemoveViewMoreWrap(grid);
        }

        if (!followHref || !document.querySelector('.ciw-view-more-wrap')) {
          return batchAdded;
        }

        var shouldContinue = batchAdded < getViewMoreBatchTarget() || added === 0;
        if (shouldContinue) {
          if (shopAllState) {
            ciwQueueShopAllViewMorePrefetch(shopAllState, followHref);
          }
          return loadViewMorePage(followHref, grid, triggerBtn, depth + 1, batchAdded, shopAllState);
        }

        return batchAdded;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-view-more]');
    if (!btn) return;
    e.preventDefault();
    if (viewMoreLoading) return;
    var nextHref = btn.getAttribute('href');
    if (!nextHref) return;

    var grid = document.getElementById('product-grid');
    if (!grid) return;

    if (ciwIsMobileCollectionView() && ciwIsFramePlpPage()) {
      var revealed = ciwRevealMobileFrameBatch(grid);
      if (revealed > 0) {
        updateViewMoreCount(grid);
        return;
      }
    }

    var label = btn.textContent.trim() === 'Try again' ? 'View More' : btn.textContent;
    btn.textContent = 'Loading...';
    btn.style.pointerEvents = 'none';
    viewMoreLoading = true;
    window.ciwViewMoreLoading = true;
    var shopAllState = null;
    var shopAllFinalized = false;

    if (ciwIsShopAllSortGrid()) {
      ciwClearStaleShopAllStoredPage();
      ciwMarkShopAllSettledCards(grid);
      shopAllState = ciwCreateShopAllViewMoreState(grid);
      var shopAllWrap = grid.closest('.ciw-product-grid-wrap--shop-all-sort');
      if (shopAllWrap) shopAllWrap.classList.add('is-view-more-loading');
    }

    nextHref = ciwMergeCollectionParamsIntoUrl(nextHref);
    btn.setAttribute('href', nextHref);
    if (shopAllState) {
      ciwQueueShopAllViewMorePrefetch(shopAllState, nextHref);
    }

    function finishShopAllViewMore(batchAdded) {
      if (!ciwIsShopAllSortGrid() || shopAllFinalized) return;
      shopAllFinalized = true;
      ciwAppendShopAllViewMoreBatch(grid, shopAllState);
      if (typeof window.ciwEyeglassesShopAllSortAppend === 'function') {
        window.ciwEyeglassesShopAllSortAppend(
          shopAllState ? shopAllState.settledCount : null
        );
      }
      updateViewMoreCount(grid);
      ciwMaybeRemoveViewMoreWrap(grid);
      var shopAllWrap = grid.closest('.ciw-product-grid-wrap--shop-all-sort');
      if (shopAllWrap) shopAllWrap.classList.remove('is-view-more-loading');
      if (batchAdded === 0) {
        ciwClearShopAllStoredNextPage();
        var resetHref = ciwShopAllViewMoreResetHref();
        if (btn.isConnected) {
          btn.setAttribute('href', resetHref);
          btn.textContent = 'Try again';
          btn.style.pointerEvents = '';
        }
        var wrap = document.querySelector('.ciw-view-more-wrap');
        if (wrap) wrap.dataset.nextPage = resetHref;
      } else if (btn.isConnected) {
        btn.textContent = 'View More';
        btn.style.pointerEvents = '';
      }
    }

    loadViewMorePage(nextHref, grid, btn, 0, 0, shopAllState)
      .then(function (batchAdded) {
        if (ciwIsShopAllSortGrid()) {
          finishShopAllViewMore(batchAdded);
          return;
        }
        if (ciwIsMobileCollectionView() && ciwIsFramePlpPage()) {
          ciwRevealMobileFrameBatch(grid);
          updateViewMoreCount(grid);
        }
        document.dispatchEvent(new CustomEvent('ciw:collection-updated'));
      })
      .catch(function () {
        finishShopAllViewMore(0);
        if (btn.isConnected) {
          btn.textContent = 'Try again';
          btn.style.pointerEvents = '';
        }
      })
      .finally(function () {
        viewMoreLoading = false;
        window.ciwViewMoreLoading = false;
        if (ciwIsShopAllSortGrid() && !shopAllFinalized) {
          finishShopAllViewMore(0);
        }
        var shopAllWrap = grid && grid.closest('.ciw-product-grid-wrap--shop-all-sort');
        if (shopAllWrap) shopAllWrap.classList.remove('is-view-more-loading');
        if (btn.isConnected && btn.textContent === 'Loading...') {
          btn.textContent = label;
          btn.style.pointerEvents = '';
        }
      });
  });

  function ciwRevealAllDesktopFrameCards() {
    if (ciwIsMobileCollectionView()) return;
    var grid = document.getElementById('product-grid');
    if (!grid || !ciwIsFramePlpPage()) return;
    grid.querySelectorAll('.ciw-card.ciw-mobile-plp-hidden').forEach(function (card) {
      card.classList.remove('ciw-mobile-plp-hidden');
      card.classList.add('ciw-mobile-plp-shown');
    });
    updateViewMoreCount(grid);
  }

  (function initViewMoreCount() {
    ciwPersistPreviewThemeId();
    ciwClearStaleShopAllStoredPage();
    var grid = document.getElementById('product-grid');
    if (grid) {
      if (grid.dataset.ciwEyeglassesShopAllSort !== 'true') {
        ciwSortGridByBrand(grid);
      }
      ciwNormalizeMobileFrameCardVisibility(grid);
      ciwRevealAllDesktopFrameCards();
      updateViewMoreCount(grid);
    }
    ciwSyncViewMoreHref();
  })();

  function scheduleMobileFrameGridReady() {
    if (!ciwIsMobileCollectionView() || !ciwIsFramePlpPage()) return;
    requestAnimationFrame(function () {
      ciwEnsureMobileFrameGridReady();
    });
  }

  scheduleMobileFrameGridReady();
  ciwEnsureShopAllFrameGridReady();
  document.addEventListener('ciw:collection-updated', function () {
    if (ciwIsShopAllSortGrid() && !ciwIsNativeEyeglassesSort()) {
      var shopAllGrid = document.getElementById('product-grid');
      if (shopAllGrid) {
        ciwNormalizeMobileFrameCardVisibility(shopAllGrid);
        updateViewMoreCount(shopAllGrid);
      }
      requestAnimationFrame(ciwRevealAllDesktopFrameCards);
      return;
    }
    if (ciwIsNativeEyeglassesSort()) {
      ciwRevealNativeSortGridNow();
    }
    scheduleMobileFrameGridReady();
    ciwEnsureShopAllFrameGridReady();
    requestAnimationFrame(ciwRevealAllDesktopFrameCards);
  });

  /* --- PLP scroll + pagination restore (back from product page) --- */
  var PLP_RESTORE_KEY = 'ciw-plp-restore';
  var PLP_RESTORE_TTL = 30 * 60 * 1000;

  function getPlpStateKey() {
    return location.pathname + location.search;
  }

  function savePlpRestoreState() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    sessionStorage.setItem(
      PLP_RESTORE_KEY,
      JSON.stringify({
        path: getPlpStateKey(),
        scrollY: window.scrollY,
        loadedCount: grid.querySelectorAll('.ciw-card').length,
        t: Date.now()
      })
    );
  }

  function readPlpRestoreState() {
    try {
      var raw = sessionStorage.getItem(PLP_RESTORE_KEY);
      if (!raw) return null;
      var state = JSON.parse(raw);
      if (!state || state.path !== getPlpStateKey()) return null;
      if (Date.now() - state.t > PLP_RESTORE_TTL) {
        sessionStorage.removeItem(PLP_RESTORE_KEY);
        return null;
      }
      return state;
    } catch (err) {
      return null;
    }
  }

  function clearPlpRestoreState() {
    sessionStorage.removeItem(PLP_RESTORE_KEY);
  }

  function isBackForwardNavigation() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    return !!(nav && nav.type === 'back_forward');
  }

  function scrollToPlpPosition(scrollY) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        window.scrollTo(0, scrollY);
      });
    });
  }

  function restorePlpUntilCount(targetCount) {
    var grid = document.getElementById('product-grid');
    if (!grid) return Promise.resolve();

    function step() {
      var current = grid.querySelectorAll('.ciw-card').length;
      if (current >= targetCount) return Promise.resolve();

      var btn = document.querySelector('[data-view-more]');
      var href = btn && btn.getAttribute('href');
      if (!href) return Promise.resolve();

      return loadViewMorePage(href, grid, btn, 0).then(step);
    }

    return step();
  }

  function runPlpRestore(persisted) {
    var state = readPlpRestoreState();
    if (!state) return;

    var grid = document.getElementById('product-grid');
    if (!grid) {
      clearPlpRestoreState();
      return;
    }

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    if (ciwIsShopAllSortGrid()) {
      scrollToPlpPosition(state.scrollY);
      clearPlpRestoreState();
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'auto';
      }
      if (typeof window.ciwEyeglassesShopAllSortRun === 'function') {
        window.ciwEyeglassesShopAllSortRun();
      }
      return;
    }

    var current = grid.querySelectorAll('.ciw-card').length;
    var finish = function () {
      scrollToPlpPosition(state.scrollY);
      clearPlpRestoreState();
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'auto';
      }
      document.dispatchEvent(new CustomEvent('ciw:collection-updated'));
    };

    if (persisted && current >= state.loadedCount) {
      finish();
      return;
    }

    if (current >= state.loadedCount) {
      finish();
      return;
    }

    restorePlpUntilCount(state.loadedCount).then(finish);
  }

  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest('#product-grid a.ciw-card__image, #product-grid a.ciw-card__info');
      if (!link) return;
      savePlpRestoreState();
    },
    true
  );

  window.addEventListener('pageshow', function (e) {
    if (e.persisted || isBackForwardNavigation()) {
      runPlpRestore(!!e.persisted);
      return;
    }
    if (readPlpRestoreState()) {
      clearPlpRestoreState();
    }
  });

  /* --- Trending carousel --- */
  (function initTrendingCarousel() {
    var section = document.querySelector('.ciw-trending:not([data-recently-viewed])');
    var track = document.querySelector('[data-trending-track]');
    if (!track || !section) return;
    var next = document.querySelector('[data-trending-next]');
    var prev = document.querySelector('[data-trending-prev]');

    function getAmount() {
      var card = track.querySelector('.ciw-card');
      return card ? card.offsetWidth + 20 : 300;
    }

    function updateScrolled() {
      section.classList.toggle('is-scrolled', track.scrollLeft > 5);
    }

    track.addEventListener('scroll', updateScrolled, { passive: true });
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        track.scrollBy({ left: getAmount(), behavior: 'smooth' });
      });
    }
    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        track.scrollBy({ left: -getAmount(), behavior: 'smooth' });
      });
    }
  })();

  /* --- Recently viewed carousel --- */
  function initMobileSearch() {
    var searchInput = document.getElementById('mobileProductSearch');
    var productGrid = document.getElementById('product-grid');
    if (!searchInput || !productGrid) return;

    function filterProducts() {
      var searchText = searchInput.value.toLowerCase().trim();
      var productCards = document.querySelectorAll('#product-grid .ciw-card');
      var matchingProducts = 0;

      productCards.forEach(function (card) {
        var productTitleElement = card.querySelector('.ciw-card__title');
        var productTitle = productTitleElement ? productTitleElement.textContent.toLowerCase() : '';

        if (searchText === '' || productTitle.includes(searchText)) {
          card.style.display = 'block';
          card.style.position = 'relative';
          matchingProducts++;
        } else {
          card.style.display = 'none';
          card.style.position = 'absolute';
        }
      });

      var noResultMessage = document.getElementById('no-results-message');
      if (!noResultMessage) {
        noResultMessage = document.createElement('div');
        noResultMessage.id = 'no-results-message';
        noResultMessage.style.textAlign = 'center';
        noResultMessage.style.padding = '20px';
        noResultMessage.style.fontSize = '18px';
        noResultMessage.style.color = '#555';
        noResultMessage.textContent = 'No products found.';
        productGrid.appendChild(noResultMessage);
      }
      noResultMessage.style.display = matchingProducts > 0 ? 'none' : 'block';
    }

    searchInput.addEventListener('input', filterProducts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileSearch);
  } else {
    initMobileSearch();
  }

  /* --- Mobile: recover when SSR grid is empty but collection has products --- */
  function ciwRecoverMobileEmptyCollectionGrid(attempt) {
    if (window.matchMedia('(min-width: 750px)').matches) return;

    var grid = document.getElementById('product-grid');
    if (!grid || !grid.classList.contains('ciw-product-grid')) return;
    if (grid.dataset.ciwEyeglassesShopAllSort === 'true') return;

    var cards = grid.querySelectorAll('.ciw-card').length;
    var emptyNote = grid.querySelector('.ciw-plp-grid-empty-note');
    if (cards > 0 || !emptyNote) return;

    var countText = (document.querySelector('.ciw-coll-title__count') || {}).textContent || '';
    var countMatch = countText.match(/(\d[\d,]*)/);
    var expectedCount = countMatch ? parseInt(countMatch[1].replace(/,/g, ''), 10) : 0;
    if (!Number.isFinite(expectedCount) || expectedCount <= 0) return;
    if (attempt > 2) return;

    var params = new URLSearchParams(window.location.search);
    if (!params.has('filter.v.availability')) {
      params.set('filter.v.availability', '1');
    }

    window.location.replace(window.location.pathname + '?' + params.toString());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(function () {
        ciwRecoverMobileEmptyCollectionGrid(1);
      }, 250);
    });
  } else {
    window.setTimeout(function () {
      ciwRecoverMobileEmptyCollectionGrid(1);
    }, 250);
  }


  /* --- Mobile filter icon button --- */
  function initMobileFilterTrigger() {
    if (window.matchMedia('(min-width: 750px)').matches) return;

    document.querySelectorAll('.ciw-mobile-filter-trigger').forEach(function (btn) {
      if (btn.dataset.ciwFilterTriggerBound) return;
      btn.dataset.ciwFilterTriggerBound = '1';

      btn.addEventListener('click', function () {
        var menu = document.getElementById('mobile-facets-menu');
        if (!menu) return;
        var summary = menu.querySelector('summary');
        if (summary) summary.click();
      });
    });
  }

  initMobileFilterTrigger();
  document.addEventListener('ciw:collection-updated', initMobileFilterTrigger);

  window.closeFilters = function () {
    var drawer = document.querySelector('menu-drawer.mobile-facets__wrapper');
    var menu = document.getElementById('mobile-facets-menu');
    if (!drawer || !menu || !menu.hasAttribute('open')) return;

    var summary = menu.querySelector('summary');
    var inner = menu.querySelector('.mobile-facets__inner');

    menu.classList.remove('menu-opening');
    document.body.classList.remove('overflow-hidden-mobile');

    var finish = function () {
      menu.removeAttribute('open');
      menu.querySelectorAll('details').forEach(function (el) {
        el.removeAttribute('open');
        el.classList.remove('menu-opening');
      });
      if (summary) summary.setAttribute('aria-expanded', 'false');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(summary);
    };

    if (!inner) {
      finish();
      return;
    }

    var closed = false;
    var onTransitionEnd = function (event) {
      if (event.propertyName !== 'transform' || closed) return;
      closed = true;
      inner.removeEventListener('transitionend', onTransitionEnd);
      finish();
    };

    inner.addEventListener('transitionend', onTransitionEnd);
    setTimeout(function () {
      if (closed) return;
      closed = true;
      inner.removeEventListener('transitionend', onTransitionEnd);
      finish();
    }, 280);
  };

  function ciwEnsureNativeSortOrderOnLoad() {
    if (!ciwIsNativeEyeglassesSort()) return;
    var grid = document.getElementById('product-grid');
    if (!grid || !grid.querySelectorAll('.ciw-card').length) return;
    ciwHandoffBootSkeletonToGrid();
    ciwApplyNativeEyeglassesSort(grid);
    ciwHideNativeSortPageOverlay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ciwEnsureNativeSortOrderOnLoad);
  } else {
    ciwEnsureNativeSortOrderOnLoad();
  }
})();
